import script from "./DiagnosticDiscussions.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagnosticDiscussions.vue?vue&type=script&setup=true&lang=js"

import "./DiagnosticDiscussions.vue?vue&type=style&index=0&id=356c7f24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-356c7f24"]])

export default __exports__